import { Injectable } from '@angular/core';

import { HttpClient } from '../_services/global-http.service';

@Injectable()
export class NewUserService {
  data: any;

  constructor(private http: HttpClient) { }

  postAddUser(newUser: any) {
    const apiAddNewUser = '/api/users/';
    this.data = this.http.post(apiAddNewUser, newUser);
    return this.data;
  }

  removeUser(id: any) {
    this.data = this.http.post('/api/users_delete/', id);
    return this.data;
  }

  putUpdateUser(updateUser: any, id: number) {
    const apiUpdateUser = '/api/user/' + id + '/';
    this.data = this.http.put(apiUpdateUser, updateUser);
    return this.data;
  }

  deleteUnlockUser(id: number) {
    const apiUnlockUser = '/api/user/' + id + '/reset_login_attempts/';
    this.data = this.http.delete(apiUnlockUser);
    return this.data;
  }

  getUserPermissions() {
    this.data = this.http.get('/api/permissions/');
    return this.data;
  }

  getModulePermissions() {
    this.data = this.http.get('/api/modules/');
    return this.data;
  }
  putUpdatePreferences(updateUser: any, id: number) {
    const apiUpdateUser = '/api/user/' + id + '/change_preferences/';
    this.data = this.http.put(apiUpdateUser, updateUser);
    return this.data;
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/new-user.service.ts